export default __webpack_public_path__ + "static/media/purple_butterflies_romper.3552e249.jpg";